var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJiraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13783_10641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9368 0.5H11.4102C11.4101 1.18332 11.5447 1.85994 11.8062 2.49125C12.0677 3.12256 12.4509 3.69618 12.9341 4.17935C13.4173 4.66253 13.9909 5.0458 14.6222 5.30728C15.2535 5.56877 15.9302 5.70334 16.6135 5.70331H18.7368V7.75344C18.7387 10.6245 21.0657 12.9516 23.9368 12.9535V1.49994C23.9368 0.947844 23.4892 0.5 22.9368 0.5Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2336 6.24219H5.70703C5.70881 9.11328 8.03578 11.4403 10.907 11.4422H13.0303V13.4989C13.034 16.37 15.3625 18.6955 18.2336 18.6955V7.24231C18.2336 6.69003 17.7859 6.24219 17.2336 6.24219Z",
    fill: "url(#paint0_linear_13783_10641)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5267 11.9844H0C0 14.8581 2.32969 17.1877 5.20331 17.1877H7.33331V19.2377C7.33519 22.1062 9.65812 24.4322 12.5267 24.4377V12.9844C12.5267 12.4321 12.0789 11.9844 11.5267 11.9844Z",
    fill: "url(#paint1_linear_13783_10641)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13783_10641",
    x1: 1233.7,
    y1: 8.24718,
    x2: 746.356,
    y2: 516.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A0A0A0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13783_10641",
    x1: 1261,
    y1: 17.6506,
    x2: 697.263,
    y2: 572.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A0A0A0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13783_10641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraIcon);
export default __webpack_public_path__ + "static/media/JiraIcon.3ee3517ab294b0744d9dd816cc028f73.svg";
export { ForwardRef as ReactComponent };